import { useContext } from 'react';
import { SlideOverContext } from '../providers/SlideOverProvider';
import { ISlideOverContext } from '../models/slideOver';

export const useSlideOverContext = (): ISlideOverContext => useContext(SlideOverContext);
